import { formValueSelector } from 'redux-form';
import isPlainObj from 'is-plain-obj';
import flatMapDeep from 'lodash/flatMapDeep';

// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import deepFilter from 'deep-filter';
export const isSelected = (name, form) => state => formValueSelector(form)(state, `${name}.value.value`) === 'true';
export const getSelection = (name, form) => state => {
  const data = formValueSelector(form)(state, name) || {};
  const {
    value: _,
    ...filteredData
  } = data;
  if (!isSelected(name, form)(state)) {
    return [];
  }
  return deepFilter(Object.values(filteredData), value => {
    if (Array.isArray(value) || typeof value === 'string') {
      return value.length > 0;
    }
    if (value && typeof value === 'object') {
      return Object.keys(value).length > 0;
    }
    return value !== null;
  });
};
const getAllAvailableSeatsForDeck = deck => {
  var _deck$cabins$flatMap;
  return (_deck$cabins$flatMap = deck === null || deck === void 0 ? void 0 : deck.cabins.flatMap(cabin => cabin === null || cabin === void 0 ? void 0 : cabin.rows.flatMap(row => {
    var _row$sellSeatMapSeats;
    return row === null || row === void 0 || (_row$sellSeatMapSeats = row.sellSeatMapSeats) === null || _row$sellSeatMapSeats === void 0 ? void 0 : _row$sellSeatMapSeats.filter(seat => (seat === null || seat === void 0 ? void 0 : seat.isBookable) && typeof seat.price === 'number');
  }))) !== null && _deck$cabins$flatMap !== void 0 ? _deck$cabins$flatMap : [];
};
export const getMinPrice = bounds => {
  const prices = bounds.flatMap(bound => bound.sellSeatMapSegments.flatMap(segment => [...getAllAvailableSeatsForDeck(segment.upperDeck), ...getAllAvailableSeatsForDeck(segment.mainDeck), ...getAllAvailableSeatsForDeck(segment.lowerDeck)])).filter(seat => Boolean(seat) && typeof (seat === null || seat === void 0 ? void 0 : seat.price) === 'number').map(seat => seat.price);
  if (prices.length === 0) {
    return 0;
  }
  return Math.min(...prices);
};
const getMarkup = (base, additional) => {
  if (typeof base !== 'number') {
    return additional;
  }
  if (typeof additional !== 'number') {
    return base;
  }
  return base + additional;
};
const addPrice = ({
  price: basePrice,
  markup: baseMarkup
}, {
  price: additionalPrice,
  markup: additionalMarkup
}) => ({
  price: basePrice + (additionalPrice !== null && additionalPrice !== void 0 ? additionalPrice : 0),
  markup: getMarkup(baseMarkup, additionalMarkup)
});
const isPriceMarkup = value => !Array.isArray(value) && isPlainObj(value) && typeof value.price === 'number';
const getPriceRecursive = input => (Array.isArray(input) ? input : [input]).reduce((total, price) => {
  if (Array.isArray(price)) {
    return addPrice(total, getPriceRecursive(price));
  }
  if (isPriceMarkup(price)) {
    return addPrice(total, price);
  }
  if (!isPlainObj(price)) {
    // Primitives carry no price info; recursing into a string would loop forever.
    return total;
  }
  return addPrice(total, getPriceRecursive(Object.values(price)));
}, {
  price: 0,
  markup: null
});
export const getPrice = (name, form) => state => {
  return getPriceRecursive(getSelection(name, form)(state));
};
export const hasSeatSelection = (seatSelection = {}) => flatMapDeep(seatSelection, bound => {
  if (!bound) {
    return [];
  }
  return Object.values(bound);
}).some(selection => selection !== null);
//# sourceMappingURL=selection.js.map